module.exports = __webpack_public_path__ + "static/media/giftFunds.db9c5845.svg";